import React from 'react';
import { Button } from 'antd';

const BtnFormSubmit = ({
  name,
  disabled,
  handleClick,
  profileId,
  isDriver,
}) => {
  const formSubmit = () => {
    handleClick(name);
  };

  return (
    <Button
      type="primary"
      htmlType="submit"
      size="large"
      style={{ width: '100%', marginBottom: 16 }}
      disabled={disabled}
      onClick={formSubmit}
    >
      {profileId
        ? 'Сохранить изменения'
        : isDriver
        ? 'Отправить запрос'
        : 'Сохранить'}
    </Button>
  );
};

export default BtnFormSubmit;
